<script setup>
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  context: {
    type: Object,
    default: () => ({}),
  },
});

const HOST_READY_EVENT = 'hkele:chatwoot-extension-host-ready';

const container = ref(null);
let slotHandle;

const destroySlot = () => {
  slotHandle?.destroy?.();
  slotHandle = undefined;
};

const mountSlot = () => {
  const extensionHost = window.ChatwootExtensions;
  if (!container.value || !extensionHost?.mountSlot) {
    return;
  }

  destroySlot();
  slotHandle = extensionHost.mountSlot({
    element: container.value,
    name: props.name,
    context: props.context,
  });
};

const handleHostReady = () => mountSlot();

watch(
  () => props.context,
  context => {
    if (slotHandle?.update) {
      slotHandle.update(context);
    } else {
      mountSlot();
    }
  },
  { deep: true }
);

onMounted(() => {
  window.addEventListener(HOST_READY_EVENT, handleHostReady);
  mountSlot();
});

onBeforeUnmount(() => {
  window.removeEventListener(HOST_READY_EVENT, handleHostReady);
  destroySlot();
});
</script>

<template>
  <div ref="container" class="contents" :data-chatwoot-extension-slot="name" />
</template>
